<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-about.png`)})`}">
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企業使命</h2>
				<div class="product product-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						從成立以來我們始終堅持以"擁抱技術，驅動產業躍遷"為核心理念，依託全球領先技術棧（雲原生、數字原生、AI原生）與自主創新能力，構建"數雲融合"戰略基座，打通數字化轉型全週期鏈路。通過信創產業適配與四大技術引擎協同，推動企業從信息化向智能化、資產化、生態化轉型，重塑數字經濟新範式。
					</div>
					<div class="pic">
						<img src="@/assets/images/about1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">行業賦能與創新</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/about2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" style="font-size: 20px">
						賦能雙引擎：敏捷底座 × 數據驅動<br>
						垂直行業場景創新<br>
						快消零售：AI需求預測模型+動態定價算法；<br>
						汽車製造：數字孿生工廠實時優化產線參數；<br>
						金融風控：整合另類數據（衛星影像/供應鏈流），提升企業信貸風險評估覆蓋度。
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Separator from '../../components/elements/separator/Separator'
import Swiper from 'swiper'

import "swiper/css/swiper.css";

export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {
		}
	},
}
</script>
<style lang="scss" scoped>
.product {
	margin-top: 72px;
	display: flex;
	gap: 20px;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		font-size: 22px;
		text-align: justify;
		display: flex;
		align-items: center;
	}
}

@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
</style>
